export default {
  pageTitles: {
    "/dashboard": "Dashboard",
    "/changes": "Detected events",
    "/sources": "Monitored Sources",
    "/portfolio": "Portfolio",
    "/alerts": "Email alerts",
    "/admin": "Users",
    "/changelog": "Version history",
    "/profile": "My Profile",
    "/notifications": "Alerts",
    "/onboarding": "Initial setup",
    "/products": "My Products",
    "/competitors": "Competitors",
    "/history": "History",
    "/trends": "Price trends",
    "/radar": "Regulatory Radar",
    "/upgrade": "Plans & subscription",
    "/prices": "Price Comparison",
    "/calendar": "Calendar",
    "/reports": "Reports",
  },
  time: {
    now: "Just now",
    minAgo: "{n} min ago",
    hourAgo: "{n}h ago",
    yesterday: "Yesterday",
    daysAgo: "{n} days ago",
  },
  topbar: {
    openMenu: "Open menu",
    viewTutorial: "View getting-started tutorial",
    notifications: "Alerts",
    markAllRead: "Mark all as read",
    noNotifications: "No new alerts",
    viewAllNotifications: "View all alerts →",
    emailPreferences: "Email preferences",
    logout: "Log out",
  },
};
